import * as Starknet from 'starknet';

import { CONTRACT_ADDRESS_PREFIX } from '#/features/wallet/chain-l2';

/** Adopted from @source https://github.com/ConsenSys/starknet-snap/blob/starknet-snap-v0.12.0/packages/starknet-snap/src/utils/starknetUtils.ts#L335 */
export default function getAccContractAddressAndCallData(
  accountClassHash: string,
  accountProxyClassHash: string,
  publicKey: string,
) {
  const callData = Starknet.stark.compileCalldata({
    implementation: accountClassHash,
    selector: Starknet.hash.getSelectorFromName('initialize'),
    calldata: Starknet.stark.compileCalldata({
      signer: publicKey,
      guardian: '0',
    }),
  });
  const address = calculateContractAddress(
    publicKey,
    accountProxyClassHash,
    callData,
  );

  return {
    address,
    callData,
  };
}

/** Adopted from @source https://github.com/ConsenSys/starknet-snap/blob/starknet-snap-v0.12.0/packages/starknet-snap/src/utils/starknetUtils.ts#L308 */
function calculateContractAddress(
  salt: Starknet.number.BigNumberish,
  contractHash: Starknet.number.BigNumberish,
  constructorCalldata: Starknet.number.BigNumberish[],
  callerAddress: Starknet.number.BigNumberish = 0,
): string {
  const constructorCalldataHash =
    Starknet.hash.computeHashOnElements(constructorCalldata);

  return Starknet.hash.computeHashOnElements([
    CONTRACT_ADDRESS_PREFIX,
    callerAddress,
    salt,
    contractHash,
    constructorCalldataHash,
  ]);
}
